import styled from "styled-components";

// Text primitives shared by the Webhooks tab and its modal (issue #41971).
export const Logo = styled.img`
    width: ${(props) => props.$size || "22px"};
    height: ${(props) => props.$size || "22px"};
    object-fit: contain;
    flex: none;
`;

export const Mono = styled.span`
    font-family: var(--font-mono);
    font-size: var(--pw-text-sm);
    color: var(--text-body);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const Muted = styled.span`
    font-size: var(--pw-text-sm);
    color: var(--text-muted);
`;
